module.exports = __webpack_public_path__ + "img/icon_close_blue.ba77b6d1.svg";